const initialState = {
  basicProfileData: {
    // classificationTag: '',
  },
  addressDetails: {},

  financialDetails: {
    gstRegistered: true,
    msmeRegistered: false
  },
  tocDetails: {},


  registerSuccess: '',
  resetPassSuccess: '',
  formSubmitSuccess: false,

  inventoryDetailsUpdated:{},
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {

    case "INVENTORY_DETAILS_UPDATED": {
      return {
        ...state,
        inventoryDetailsUpdated: action.payload
      }
    }

    case "FORM_SUBMIT_SUCCESS":
      return {
        ...state,
        formSubmitSuccess: action.payload,
      };

    case "REGISTER_SUCCESS_MESSAGE":
      return {
        ...state,
        registerSuccess: action.payload,
      };


      case "RESET_PASS_SUCCESS_MESSAGE":
        return {
          ...state,
          resetPassSuccess: action.payload,
        };
      



    case "BASIC_PROFILE_DATA":
      return {
        ...state,
        basicProfileData: action.payload,
      };

      case "ADDRESS_DETAILS":
        return {
          ...state,
          addressDetails: action.payload,
        };


      case "FINANCIAL_DETAILS":
        return {
          ...state,
          financialDetails: action.payload,
        };



      case "TOC_DETAILS":
        return {
          ...state,
          tocDetails: action.payload,
        };

    default:
      return state;
  }
};

export default profileReducer;
